import RaterAccountsService from "@/services/raterAccounts.service";
import { DefineActions } from "vuex-type-helper";
import * as types from "@/store/mutation-types";
import {
  RaterAccountsActions,
  RaterAccountsGetters,
  RaterAccountsMutations,
  RaterAccountsState
} from "./types";

export const actions: DefineActions<
  RaterAccountsActions,
  RaterAccountsState,
  RaterAccountsMutations,
  RaterAccountsGetters
> = {
  async getRaterAccountStatus({ commit }) {
    try {
      commit(types.SET_STATE, { key: "makingApiRequest", value: true });
      const response = await RaterAccountsService.getStatus();
      commit(types.SET_STATES, {
        status: response.data,
        lastUpdate: new Date()
      });
      return response.data;
    } finally {
      commit(types.SET_STATE, { key: "makingApiRequest", value: false });
    }
  },
  async resetRaterAccounts({ commit }, force = false) {
    try {
      commit(types.SET_STATE, { key: "makingApiRequest", value: true });
      const response = await RaterAccountsService.reset(force);
      commit(types.SET_STATE, { key: "resetResult", value: response.data });
      return response.data;
    } finally {
      commit(types.SET_STATE, { key: "makingApiRequest", value: false });
    }
  }
};
